'use client'

import { useModalContext } from '@context/ModalContext/ModalContext'
import { useUserContext } from '@context/UserContext/UserContenxt'
import { createContext, type ReactNode, useContext, useState } from 'react'

// Interface to define the return structure of the hook

// Define the types

interface WidgetContextType {
  widgetModal: boolean
  setWidgetModal: Function
  vehicleData: object
  setVehicleData: Function
  regNo: string
  setRegNo: Function
  show: boolean
  setShow: Function
  userData: any // Replace with the correct type for user data
  phone: string
  setPhone: Function
  setUserLoggedIn: Function
  isLoggedIn: boolean | undefined
}

const WidgetContext = createContext<WidgetContextType | undefined>(undefined)

interface WidgetProviderProps {
  children: ReactNode
}

export const WidgetProvider: React.FC<WidgetProviderProps> = ({ children }) => {
  const [widgetModal, setWidgetModal] = useState<boolean>(false)
  const [vehicleData, setVehicleData] = useState<object>({})
  const [regNo, setRegNo] = useState<string>('')
  const { isLoggedIn, setUserLoggedIn, userData } = useUserContext() // Assuming you already have this hook
  const [phone, setPhone] = useState<string>('')
  const { show, setShow } = useModalContext() // Assuming you have this modal context

  const contextValue: WidgetContextType = {
    widgetModal,
    setWidgetModal,
    vehicleData,
    setVehicleData,
    regNo,
    setRegNo,
    show,
    setShow,
    userData,
    phone,
    setPhone,
    setUserLoggedIn,
    isLoggedIn,
  }

  return <WidgetContext.Provider value={contextValue}>{children}</WidgetContext.Provider>
}

export const useWidgetContext = () => {
  const context = useContext(WidgetContext)
  if (!context) {
    throw new Error('useWidgetContext must be used within a WidgetProvider')
  }
  return context
}
